import { onLogin, apolloClient } from '@/plugins/vue-apollo.js';
import { mutation } from '@/core/methods/mutation.js';

const adminSignIn = (phone, password) => {
	let auth;
	let variables = {
		phone: phone,
		password: password
	};

	let mutationPath = 'user/api/mutations/signin_mutaion';
	auth = mutation(variables, mutationPath)
		.then((data) => {
			return setUserAndToken(apolloClient, data);
		})
		.catch((error) => {
			// console.log(error.message.toString());

			return JSON.stringify(error.message);

		});
	return auth;
};

// set role & user & token
function setUserAndToken(apolloClient, data) {
	onLogin(apolloClient, data.data.adminSignIn.token);
	if (typeof localStorage !== 'undefined') {
		localStorage.setItem('DONE_USER', JSON.stringify(data.data.adminSignIn.user));
		localStorage.setItem('DONE_USER_ROLE', data.data.adminSignIn.user.role);
		localStorage.setItem('DONE_USER_PERMISSIONS', data.data.adminSignIn.permissions);
		if (data.data.adminSignIn.userRoles) {
			let permissions = JSON.stringify(data.data.adminSignIn.userRoles);
			localStorage.setItem('DONE_USER_ROLE_PERMISSIONS', permissions);
		}
	}
	// location.reload();
	return true;
}

export { adminSignIn };
